import { useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import withLoader from "../../../components/layouts/WithLoader";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DataTableListInventaire from "./DataTableListInventaire";
import { useNavigate } from "react-router-dom";

const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };
const labelStyle = {
  fontSize: "0.8rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.03em",
  color: "#6c757d",
};

const AllInventaire = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [listInventaire, setListInventaire] = useState([]);
  const [searched, setSearched] = useState(false);
  // incrémenté à chaque recherche pour remonter le tableau (données à jour)
  const [tableVersion, setTableVersion] = useState(0);

  const [allWarehouses, setAllWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState(0);
  const [warehouseOption, setWarehouseOption] = useState(null);

  useEffect(() => {
    startLoading();
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setAllWarehouses(
            response.data.success.map((element) => ({
              value: element.id,
              label: element.name,
            }))
          );
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const onChangeSelectedWarehouse = (selectedOptionn) => {
    setWarehouseOption(selectedOptionn);
    setWarehouseId(selectedOptionn.value);
  };

  const onGetInventaireByFiltersHandler = () => {
    startLoading();
    WarehouseService.getListInventaireWarehouse(getCurrentUserId(), warehouseId)
      .then((response) => {
        setListInventaire(
          Array.isArray(response.data.success) ? response.data.success : []
        );
        setSearched(true);
        setTableVersion((v) => v + 1);
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      })
      .finally(() => {
        stopLoading();
      });
  };

  const onAddInventaireHandler = () => {
    navigate(`/addInventaire`);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenErrorAlert(false);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-clipboard-check mr-2"></i>Inventaires
              </h4>
              <small className="text-muted">
                Consultez les inventaires d'un dépôt ou lancez-en un nouveau
              </small>
            </div>
            <button
              className="btn btn-dark mt-2 mt-sm-0 d-inline-flex align-items-center"
              style={{
                borderRadius: 8,
                padding: "8px 18px 8px 10px",
                fontWeight: 500,
              }}
              onClick={onAddInventaireHandler}
            >
              <span
                className="d-inline-flex align-items-center justify-content-center mr-2"
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: 6,
                  backgroundColor: "rgba(255,255,255,.18)",
                }}
              >
                <i className="fas fa-plus" style={{ fontSize: 12 }} />
              </span>
              Nouvel inventaire
            </button>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="card card-outline card-dark mt-3" style={cardStyle}>
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-filter mr-2"></i>Filtre
              </h3>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group mb-0">
                    <label style={labelStyle}>Dépôt</label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      value={warehouseOption}
                      onChange={onChangeSelectedWarehouse}
                      options={allWarehouses}
                      placeholder="Choisir un dépôt..."
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-right">
              <button
                className="btn btn-dark"
                onClick={onGetInventaireByFiltersHandler}
              >
                <i className="fas fa-search mr-1"></i>
                Valider le choix
              </button>
            </div>
          </div>

          {listInventaire.length > 0 && (
            <DataTableListInventaire
              key={`inv-${tableVersion}`}
              listInventaire={listInventaire}
            />
          )}

          {searched && listInventaire.length === 0 && (
            <div className="text-center text-muted py-5">
              <i className="fas fa-clipboard-list fa-2x mb-2 d-block"></i>
              Aucun inventaire pour ce dépôt
            </div>
          )}
        </div>
      </section>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={3000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AllInventaire);
